import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {IdentityUser} from '../types/IdentityUser.types'

const queryKey = 'general-user-search'

export const useIdentityUserSearch = (
  searchTerm?: string,
  options?: Omit<UseQueryOptions<IdentityUser[], AxiosError>, 'queryKey'>
) => {
  return useQuery<IdentityUser[], AxiosError>({
    queryKey: [queryKey, searchTerm],
    queryFn: async () => {
      if (!searchTerm) {
        return Promise.resolve([])
      }
      const response = await ApiClient.axiosInstance.get<IdentityUser[]>('/users', {
        params: {
          name: searchTerm
        }
      })
      return response.data
    },
    refetchOnWindowFocus: false,
    ...options
  })
}
